import {assert} from 'Asserts';
import {DataFrameSpec} from 'data-frames/DataFrameTypes';
import {makeReactContext} from 'lib/makeReactContext';

const EMPTY_DATA_FRAME_SPEC: DataFrameSpec = {name: 'Input dataset', columns: []};

export const StepConfigEditorContext = makeReactContext<{
  // We don't always have access to a persisted data frame, which is why this is optional. Is needed for any
  // editor components that require using the values of the data frame.
  dataFrameId?: string;
  // Usually the pipelineId, but for the TransformPopover in the flowchart its the step id because it is hard
  // to get the pipelineId, and the stepId works because you can't have the popover open while changing the
  // stepId.
  clientStateId: string;
  /**
   * Mapping of input step data names to data frame specs.
   *
   * Input step data names are part of the step config shape. See `inputDataName` in `PipelineConfigJsonSpec`.
   *
   * This mapping can be created from an existing `PipelineStep` with `getInputStepDatasRecord`.
   */
  inputDataFrames: Record<string, Array<DataFrameSpec>>;
}>(() => {
  assert(false, 'StepConfigEditorContext not initialized');
}, 'StepConfigEditorContext');

export function useStepConfigEditorContext(): {
  dataFrameId?: string;
  clientStateId: string;
  inputDataFrames: Record<string, Array<DataFrameSpec>>;
} {
  return StepConfigEditorContext.useContext();
}

/**
 * Get a data frame spec or, if no input data frame is present, an empty spec.
 *
 * Default to an empty spec, rather than raising an exception, because an editor may be rendered
 * (in read-only) even if there is missing input, so the user can view the config.
 *
 * @param inputDataFrames Mapping of input step data names to data frame specs.
 * @oaram inputDataName Key of inputDataFrames
 */
export function getDataFrameSpecOrEmptySpec(
  inputDataFrames: Record<string, Array<DataFrameSpec>>,
  inputDataName: string
): DataFrameSpec {
  return inputDataFrames[inputDataName] && inputDataFrames[inputDataName].length > 0
    ? inputDataFrames[inputDataName][0]
    : EMPTY_DATA_FRAME_SPEC;
}
